export default {
  messages: {
    en: {
      heading: `Loading entrepreneur data&hellip;`,
      lenderGridHeading: `Supporters of {name}`,
      linkToSearch: `View all loans &gt;`,
      teamGridHeading: `Teams supporting {name}`,
      updateGridHeading: `Updates`,
    },
  },
}
